var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.23 30.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.12,0C6.78,0,0,6.78,0,15.12s6.78,15.12,15.12,15.12,15.12-6.78,15.12-15.12S23.45,0,15.12,0Zm0,28.63c-7.45,0-13.52-6.06-13.52-13.52S7.66,1.6,15.12,1.6s13.52,6.06,13.52,13.52-6.06,13.52-13.52,13.52Zm2.46-11.7l-1.35.93c-.29-.04-1.18-.56-2.23-1.77-1.05-1.22-1.44-2.17-1.43-2.46l1.13-1.2c.92-1.01.1-2.97-.67-4.04-1.13-1.56-2.1-1.36-2.46-1.2-2.02.9-3.02,2.67-2.81,4.98.39,4.35,5.02,9.8,9.17,10.8.47.11.92.17,1.35.17,1.66,0,3.06-.81,4.04-2.35.21-.34.56-1.27-.83-2.61-.95-.92-2.77-2.01-3.91-1.25Zm-.28,4.49c-3.53-.85-7.62-5.67-7.95-9.39-.14-1.59.45-2.71,1.77-3.33.2.11.65.55,1.03,1.32.37.75.39,1.25.38,1.32l-1.18,1.26c-1.14,1.25.63,3.59,1.45,4.53.82.95,2.87,3.04,4.29,2.09l1.37-.96c.12-.03.61.06,1.3.54.71.49,1.08,1,1.16,1.21-.87,1.31-2.05,1.77-3.61,1.39Z",
    fill: "#75e8f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e40ecb9f2d109e064aa80bf48224cb01.svg";
export { ForwardRef as ReactComponent };